import { inputGeneratorOneDimension } from "../../../components/generic-financial-model/HelperFunctions";
import { flatten } from "../../../helpers/miscHelpers";
import { OutputItem } from "../../../services/types/gallus";
import { dataLocation } from "./CelinkFinancialModelStaticData";

/**
 * Helper function that creates outputs for the spreadshet API. It takes the data from a dataLocation object to programatically generate all the outputs necessary.
 * @param dataInSpreadsheet This value contains where the data is located in the spreadsheet. dataLocation represents a single chart, and an array represents a KPI.
 * @param useRow If true, the static value of the dataLocation element is the Row, and the dynamic one is the column, and viceversa.
 * @returns
 */
export const FinancialModelCelinkOutputsHelper = (
  dataInSpreadsheet: dataLocation[][],
  useRow: boolean,
) => {
  var resultSet: OutputItem[][] = [];
  dataInSpreadsheet.map((row) => {
    row.map((value) => {
      resultSet.push(
        inputGeneratorOneDimension(
          useRow,
          value.staticValue,
          value.initialDynamicValue,
          value.finalDynamicValue,
        ),
      );
    });
  });

  return flatten(resultSet);
};
